<template>
    <div class="dialog" v-if="dialogShow">
        <div class="content">
            <div class="imgdiv"><img src="https://file.40017.cn/tcservice/wxapp/h5/image/order/viewapporder.png"></div>
            <div class="goAppTitle">需要前往同程旅行APP查看订单</div>
            <div class="goAppSubTitle">在APP内还可以随时查看更多消息哦！</div>            
            <div class="buttons">
                <div class="gotoapp" style=""  @click="goapporder">前往APP</div>
                <div class="stayhere" style="" @click="stayhere">继续访问我的订单</div>                
            </div>
        </div>
    </div>
</template>
<script>
    import Bus from './bus.js'
    export default {
        props:{
            isView:Boolean
        },
        data(){
            return {
                dialog:{                  
                    callbackf:function(){}
                },
                dialogShow:false,
            }
        },
        mounted() {
            let me = this;            
            Bus.$on('showviewapporder', (dialog) => {                
                me.dialogShow = true;                
                setTimeout(function(){            
                    AppendTrack("my_orders", "app_transfer_window", "h5_minapp_my_orders920", "^弹窗曝光^")
                },500)                   
            })
             Bus.$on('hideviewapporder', () => {
                // me.dialog = dialog;
                me.dialogShow = false;
                AppendTrack("my_orders", "app_transfer_window", "h5_minapp_my_orders920", "^弹窗点击^CLOSE^")
            })                           
        },
        methods:{
            stayhere(){
                this.dialogShow = false;
                AppendTrack("my_orders", "app_transfer_window", "h5_minapp_my_orders920", "^弹窗点击^WXH5^")
            },
            goapporder(callbackf){
                this.dialogShow = false;
				window.location.href ="https://m.ly.com/app/links/orderCenter/all?refresh=1&backToMine=&from=%E5%85%AC%E4%BC%97%E5%8F%B7&wakeNew=1&wakeRetry=1&wakeNext=0&wakePwdId=0&wakeDS=1&wakeRefid=2000216444"
                AppendTrack("my_orders", "app_transfer_window", "h5_minapp_my_orders920", "^弹窗点击^APP^")
                if(typeof callbackf === 'function'){
                    callbackf()
                }
            },
           

        }
    }
</script>
<style scoped>
.dialog{
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 1001;
    left: 0;
    top: 0;
    overflow: auto;
    background: rgba(0, 0, 0, 0.7);
}

.content{
    background: #fff;
    width: 320px;
    height: 445px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%, -50%, 0);
    transform: translate3d(-50%, -50%, 0);
    box-sizing: border-box;
    border-radius: 10px;
    z-index: 1001;    
}
.imgdiv{
    width: 212.5px;
    height: 169px;    
    margin-left: auto;
    margin-right: auto;    
    margin-top: 31px;
    margin-bottom: 20px;
}
.imgdiv img{
    width: 100%;
    height: 100%;
    
}
.goAppTitle{
   font-size: 18px;
   color: #2E2E2E;
   font-family: PingFang-SC-Bold;
   font-weight: bold;
   text-align: center;
   width: 100%;
   margin-bottom:9px;
}

.goAppSubTitle{
   font-size: 14px;
   color: #666666;
   font-family: PingFang-SC-Regular;
   font-weight: regular;
   text-align: center;
   width: 100%; 
}

.buttons{
    display: flex;
    -webkit-box-align:center;
	-webkit-box-pack:justify;
    flex-direction:column;
    align-content: space-between;
    margin: 24px 0px 35px 0px;
    width: 100%;
    height: 100px;
}
.buttons div{
    padding: 0;    
    width: 240px;
    display: inline-block;
    float: none;
    text-align: center;
    height: 45px;
    border-radius: 45px;
    cursor: pointer;
    margin-left: auto;
    margin-right: auto;
}
.gotoapp{
    background-color: #EB604F;
    color:#FFFFFF;
    font-size: 16px;
    line-height: 45px;
    font-family: PingFang-SC-Medium;
    font-weight: medium;    
}

.stayhere{
    background-color: #fff;
    color:#999999;
    font-size: 13px;
    line-height: 45px;
    font-family: PingFang-SC-Medium;
    font-weight: medium;
    border: 1px #D3D3D3 solid;
    margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/toappmodel.vue